import SpinnerLottery from "./spinner-lottery/index";

export default SpinnerLottery;
